import { ICON_ALERT_WARNING } from 'Config/Icons';
import { iso8601ToUsDateLong } from 'Helpers/DateTimeUtils/DateTimeUtils';
import { GovernanceStatus, GovernanceVersion, getHumanReadableGovernanceType } from 'Models/Governance';

import { GenericTooltip, IconColor } from './GenericTooltip';

export const FutureGovernanceVersionTooltip = (props: { version: GovernanceVersion }) => {
    if (props.version.status === GovernanceStatus.ACTIVE && props.version.has_future_effective_date) {
        return <GenericTooltip title="Future Version" text={`This ${getHumanReadableGovernanceType(props.version.type)} will not become active until ${iso8601ToUsDateLong(props.version.effective_date)}.`} fontAwesomeIcon={ICON_ALERT_WARNING} iconColor={IconColor.YELLOW} />;
    } else {
        return <></>;
    }
};
